import { SelectBoxItem } from '@selina-finance/ui/build/components/SelectBox';

import { repaymentMethodConfig } from '@Shared/helpers/fullEarlyRepaymentMethods';

export enum QuestionPageFormKeys {
    fullEarlyRepayment = 'fullEarlyRepayment',
    fullEarlyRepaymentYear = 'fullEarlyRepaymentYear',
    fullEarlyRepaymentMethod = 'fullEarlyRepaymentMethod',
    drawdownFlexibility = 'drawdownFlexibility',
    drawdownFlexibilityTerm = 'drawdownFlexibilityTerm',
    monthlyOverpaymentsPlanned = 'monthlyOverpaymentsPlanned',
    yearlyOverpaymentAmountKnown = 'yearlyOverpaymentAmountKnown',
    neededAmountAndTimeKnown = 'neededAmountAndTimeKnown',
    moreThan10PercentNoFeesOverpaymentPlanned = 'moreThan10PercentNoFeesOverpaymentPlanned',
}

export const mixpanelEventNames: Record<string, string> = {
    fullEarlyRepayment: 'Early redemption',
    fullEarlyRepaymentYear: 'Early redemption year',
    drawdownFlexibility: 'Flexibility',
    monthlyOverpaymentsPlanned: 'Overpayments planned',
    yearlyOverpaymentAmountKnown: 'Overpayment known',
    neededAmountAndTimeKnown: 'Drawdown known',
    moreThan10PercentNoFeesOverpaymentPlanned: 'Overpayment of over 10%',
};

export const fullEarlyRepaymentMethodItems: SelectBoxItem[] =
    repaymentMethodConfig.map(({ label, value }) => ({ label, value }));

export const drawdownFlexibilityTermItems = (): SelectBoxItem[] => {
    const minFlexibilityTerm = 2;
    const maxFlexibilityTerm = 5;
    const years = [];

    for (let i = minFlexibilityTerm; i <= maxFlexibilityTerm; i++) {
        years.push(i);
    }
    return years.map((year) => ({
        label: `${year} years`,
        value: `${year} years`,
    }));
};
